export function addressConcat(
	street?: string,
	houseNumber?: string,
	neighborhood?: string,
	uf?: string,
	cep?: string
) {
	return [street, houseNumber, neighborhood, uf, cep]
		.filter((value) => value && value.trim().length !== 0)
		.join(", ");
}
